import { get, put } from "../helpers/api_helper";

const USER_BASE_URL = "/users";
const USER_ORDERS_BASE_URL = "/users/shop/order-history/badge";

export const getUserService = () => get(`${USER_BASE_URL}/me`);
export const getUserTotalCoinsService = () =>
  get(`${USER_BASE_URL}/total-coins`);
export const setLocationService = (payload, rejectWithValue) =>
  put(`${USER_BASE_URL}/set-location`, payload, {}, rejectWithValue);

export const getProfileOrderAndServicesCountBadgesService = (
  params,
  rejectWithValue
) => get(`${USER_ORDERS_BASE_URL}`, { params }, rejectWithValue);
